import { useState, useEffect } from 'react';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _ProductionPlan } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import useModal, { MODAL_md } from '../../../../theme/Component/hooks/useModal';
import usePaginator from '../../../../theme/Component/usePaginator';
import { Modal } from '../../../../theme/Component/Modal';
import { BasicTable } from '../../../../theme/Component/BasicTable';
import { SelectProductEditor } from '../../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor';
import { AccountantYear } from './AccountantYear';
import { MonthEditorbyconst } from '../../../../RemoteAbstractAction/editors/MonthEditorbyconst';
import { BasicButton } from '../../../../theme/Component/BasicButton';
import { _single } from '../../../../../core/services/dataBean/EntityCatalog';


interface Props {
    idSelector: number;
    onChange: any;
    label?: string;
    returnType?: "ID" | "Object";
    render?: string;
}

export const ProductionPlanEditor = ({ idSelector, onChange, label, returnType = "ID", render }: Props) => {

    const { instance, lista, setLista } = useDataBean(_ProductionPlan)
    const [id, setID] = useState(null);
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const [Months, setMonths] = useState<any>(null)
    const [product, setProduct] = useState<number>(null);
    const modal = useModal("Plan de Producción", MODAL_md);
    const paginador = usePaginator();
    useEffect(() => {
        setID(idSelector)
    }, [idSelector])

    const setValue = (e: string) => {
        const selectedId = parseInt(e);
        setID(selectedId);
        if (onChange) {
            const selectedItem = lista.find(
                (item) => item?.DataBeanProperties?.IDProductionPlan == e
            );
            if (selectedItem) {
                onChange(returnType === "Object" ? selectedItem?.DataBeanProperties : selectedId);
            } else {
                onChange(returnType === "Object" ? {} : null);
            }
        }
    };

    useEffect(() => {
        getLista();
    }, [paginador.page])


    const getLista = () => {

        instance.getProductionPlanCatalog(product, Year, Months, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    setLista(resp.List)
                }

            }
        )

    }
    const head = [
        { title: 'ID', property: 'IDProductionPlan', visible: true },
        { title: 'Producto', property: 'ProductName', visible: true },
        { title: 'Unidad de Medida', property: 'MeasurementUnitName', visible: true },
        { title: 'Proyecto', property: 'ProjectName', visible: true },
        { title: 'Observaciones', property: 'Observations', visible: true },



    ]
    const abrirModal = () => {
        modal.open();
    }


    return (
        <>
            <label>{label ?? "Plan de Producción"}</label>
            <span className='form-control cursor ifmodal' onClick={abrirModal}>{render ?? ''}</span>
            <Modal modal={modal.modal} updateModal={modal.setModal}>
                <div className="row">
                    <div className="col-md-4">
                        <SelectProductEditor label="Producto Final" value={product} onChange={(e) => { setProduct(e.IDProduct) }} />
                    </div>
                    <div className="col-md-4">
                        <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
                    </div>
                    <div className="col-md-4">
                        <MonthEditorbyconst idSelector={Months} onChange={(e) => { setMonths(e) }} />
                    </div>
                    <div className="col-md-4 mt-4 p-2">
                        <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                            Buscar
                        </BasicButton>
                    </div>
                </div>
                <BasicTable head={head} body={lista} rowSet={(e) => { setValue(e.IDProductionPlan); modal.close(); }} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </Modal>
        </>
    )
}